import * as React from 'react';
import { SortableHandle } from 'react-sortable-hoc';
import { useStyles } from './styles';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import FabCreate from '../../Atoms/FabCreate/';
import Paper from '@material-ui/core/Paper';
import arrayMove from 'array-move';
import clsx from 'clsx';

import { SortableContainer, SortableElement } from 'react-sortable-hoc';
// import classes from '*.module.css';

interface ISimpleCollection {
    /** Dark mode means drag handle is light */
    mode: 'dark' | 'light';
    /** Type of content items */
    type: 'list' | 'card';

    /** Function used to render each item in the collection */
    itemRender: (value: any, index: number) => {};

    /** Enable to scroll to bottom when data is updated (e.g. when used for chat) */
    stickToBottom?: boolean;
    /** Function to be invoked when Create button is clicked */
    onCreate?: Function;
    maxHeight?: string;
    minHeight?: string;
    height?: string;
    /** The data collection to render */
    data: any[];

    /** enable/disable ability to re-order */
    reorderable?: boolean;

    /** callback to be fired after items are re-ordered */
    onSort?: Function;
    /** value to position the fab */
    fabPosition?: 'static' | 'absolute' | 'relative';

    /** value to position the fab to the right */
    fabRight?: string;

    /** value to position the fab to the left */

    fabLeft?: string;
}

/** This component allows you to easily manage a collection of items, either lists or cards.  */

export interface ISortEndProps {
    oldIndex: number;
    newIndex: number;
}

const SimpleCollection = ({
    data,
    fabLeft,
    fabPosition,
    fabRight,
    height = 'auto',
    itemRender,
    maxHeight = 'auto',
    minHeight = 'auto',
    mode,
    onCreate,
    onSort,
    reorderable,
    stickToBottom = false,
    type,
}: ISimpleCollection) => {
    const classes = useStyles({ type, mode });
    const collectionRef = React.useRef<HTMLUListElement>(null);
    const scrollToBottom = () => {
        if (collectionRef && collectionRef.current) {
            collectionRef.current.scrollTop = collectionRef.current.scrollHeight;
        }
    };
    //Useful for chat windows
    React.useEffect(() => {
        if (stickToBottom) {
            scrollToBottom();
        }
    }, [data, stickToBottom]);
    const handleOnSortEnd = ({ newIndex, oldIndex }: ISortEndProps) => {
        let updated = arrayMove(data, oldIndex, newIndex);
        updated.forEach((item, index) => {
            let updated = {
                id: item.id,
                index,
            };
            if (onSort) onSort(updated);
        });
    };

    const SortableMember = SortableElement(({ type, value }: any) => {
        if (type === 'list') {
            return value();
        } else {
            return (
                <li className={classes.sortableMember}>
                    {reorderable && <DragHandle />} {value()}
                </li>
            );
        }
    });
    const DragHandle = SortableHandle(() => <DragIndicatorIcon className={classes.dragHandle} />);

    const SortableCollection = SortableContainer(({ items, render, type }: any) => {
        return (
            <ul data-cy="SimpleCollection" className={classes.sortableCollection} ref={collectionRef}>
                {items.map((value: any, index: number) => (
                    <SortableMember
                        disabled={reorderable ? !reorderable : true}
                        index={index}
                        key={`item-${value.id}`}
                        type={type}
                        value={() => render(value, index)}
                    />
                ))}
            </ul>
        );
    });
    return (
        <Paper className={clsx(classes.root)} style={{ height: height, maxHeight: maxHeight, minHeight: minHeight }}>
            {onCreate && (
                <FabCreate
                    action={onCreate}
                    left={fabLeft ? fabLeft : 'auto'}
                    position={fabPosition ? fabPosition : 'static'}
                    right={fabRight ? fabRight : 'auto'}
                />
            )}
            <SortableCollection
                axis={type === 'list' ? 'y' : 'xy'}
                helperClass={classes.sortableCollectionWrapper}
                items={data}
                onSortEnd={handleOnSortEnd}
                render={itemRender}
                type={type}
                useDragHandle
            />
        </Paper>
    );
};

export default SimpleCollection;
